import type { ReactNode } from 'react';
import { usePermissions, type PermissionAction, type PermissionModule } from '@/hooks/use-permissions';
import { BrandSplash } from '@/components/BrandSplash';
import { NoAccess } from './NoAccess';

interface Props {
  module: PermissionModule | string;
  action: PermissionAction;
  children: ReactNode;
  /** Custom denied state instead of <NoAccess />. */
  fallback?: ReactNode;
}

/** Route guard. While permissions load shows the brand splash; if denied,
 *  shows <NoAccess /> (or `fallback`); otherwise renders children. */
export function RequirePermission({ module, action, children, fallback }: Props) {
  const { can, isLoading } = usePermissions();
  if (isLoading) return <BrandSplash />;
  if (!can(module, action)) return <>{fallback ?? <NoAccess />}</>;
  return <>{children}</>;
}
